import axios from 'axios'

export default {
	login (request = {}) {
		return axios.post('/api/auth/login', request)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
	},
	loginSocial (code) {
		return axios.get(`/api/auth/login/leaderid/callback?code=${code}`)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
	},
	checkUser () {
		return axios.get('/api/auth/user')
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
	},
	logout () {
		return axios.get('/api/auth/logout')
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
	}
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/auth.js